import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PromisePool } from 'es6-promise-pool';
import classnames from 'classnames';
import {
  Button,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  APIupdateCollectionPermissions,
  APIgetCollectionsWithPermissions,
} from '../../api/Collections';
import {
  APIupdateFilePermissions,
  APIgetFilesWithPermissions,
  APIupdateFile,
} from '../../api/Files';
import { APIgetGroups } from '../../api/Group';
import { APIgetUsers } from '../../api/User';

import { updateCollectionOnCollectionsList } from '../../actions/Collections';
import {
  addFileToFilesList,
  removeFilesFromFilesList,
  updateFilesOnFilesList,
  updateFilesOnSelectedFilesList,
} from '../../actions/Files';

import AccessModalHeader from './ModalHeader';
import AccessModalAccess from './ModalAccess';
import AccessModalAccessTypeDropdown from './ModalAccessTypeDropdown';
import AccessModalSpreadPermissions from './ModalSpreadPermissions';
import AccessModalSpreadPermissionsPublic from './ModalSpreadPermissionsPublic';
import AccessModalAccessEdition from './ModalAccessEdition';
import AccessModalNotifications from './ModalNotifications';
import ProcessingProgress from '../ProcessingProgress';
import ProcessingSpinner from '../ProcessingSpinner';
import ShareModal from '../Share/Modal';

import { sendTrackingEvent } from '../../helpers';
import {
  userCan,
  userHasCap,
  userIsAdmin,
  userIsSuperAdmin,
} from '../../helpers/Auth';
import { eventDispatch } from '../../helpers/Events';
import { addFlashMessage } from '../../helpers/FlashMessages';
import {
  getSetting,
  getUserSetting,
} from '../../helpers/Settings';
import { performOnboardingStep } from '../../helpers/Onboarding';

import ErrorBoundary from '../ErrorBoundary';
import Loading from '../Loading';

class AccessModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: null,
      files: [],
      filesCount: 0,
      filesLoading: true,
      collections: [],
      collectionsCount: 0,
      collectionsLoading: true,
      users: [],
      usersLoading: false,
      groups: [],
      groupsLoading: false,
      accessTouched: false,
      view: null,
      saving: false,
      updatedItems: 0,
      accessType: null,
      spreadPermissions: true,
      spreadPermissionsAlways: true,
      spreadPermissionsCollections: true,
      spreadPermissionsPublic: userCan('file.create_public'),
      sendNotifications: !getSetting('cs1'),
      linkSettingsOpen: false,
      userRemoveAlertOpen: false,
      ownerUuids: [],
      shareLink: false,
      addingTemplate: false,
    };

    this.addSelected = this.addSelected.bind(this);
    this.removeSelected = this.removeSelected.bind(this);
    this.addSelectedUser = this.addSelectedUser.bind(this);
    this.removeSelectedUser = this.removeSelectedUser.bind(this);
    this.addSelectedGroup = this.addSelectedGroup.bind(this);
    this.removeSelectedGroup = this.removeSelectedGroup.bind(this);
    this.addNewGroup = this.addNewGroup.bind(this);
    this.addNewUser = this.addNewUser.bind(this);
    this.resetView = this.resetView.bind(this);
    this.openSettings = this.openSettings.bind(this);
    this.openLinkSettings = this.openLinkSettings.bind(this);
    this.toggleUserRemoveAlert = this.toggleUserRemoveAlert.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChangeAccessType = this.handleChangeAccessType.bind(this);
    this.handleChangeSpreadPermissions = this.handleChangeSpreadPermissions.bind(this);
    this.handleChangeSpreadPermissionsAlways = this.handleChangeSpreadPermissionsAlways.bind(this);
    this.handleChangeSpreadPermissionsPublic = this.handleChangeSpreadPermissionsPublic.bind(this);
    this.handleChangeSpreadPermissionsCollections =
      this.handleChangeSpreadPermissionsCollections.bind(this);
    this.handleChangeSearchable = this.handleChangeSearchable.bind(this);
    this.handleChangeSendNotifications = this.handleChangeSendNotifications.bind(this);
    this.handleEditionUpdate = this.handleEditionUpdate.bind(this);
    this.handleAddingTemplate = this.handleAddingTemplate.bind(this);
    this.getEditionView = this.getEditionView.bind(this);
  }

  componentDidMount() {
    this.setInitialState();
    this.loadUsers();
    this.loadGroups();

    sendTrackingEvent('access-modal-open');
  }

  getItems(forceMode = null) {
    const {
      mode,
      files,
      collections,
    } = this.state;

    let items = [];
    if (mode === 'files') {
      items = files;
    }
    if (mode === 'collections') {
      items = collections;
    }

    if (forceMode === 'files') {
      items = files;
    }
    if (forceMode === 'collections') {
      items = collections;
    }

    return items;
  }

  getSelected(type) {
    const {
      filesLoading,
      collectionsLoading,
    } = this.state;

    if (filesLoading || collectionsLoading) {
      return [];
    }

    const items = this.getItems();

    let selected = [];
    items.forEach((item) => {
      if (type === 'groups') {
        selected = selected.concat(item.allowed_groups);
      }
      if (type === 'users') {
        selected = selected.concat(item.allowed_users);
      }
    });
    const selectedGroupped = window._.countBy(selected);

    return selectedGroupped;
  }

  setInitialFormData() {
    const { mode } = this.state;

    const items = this.getItems();

    let publicAccess = 0;
    let restrictedAccess = 0;
    items.forEach((item) => {
      if (item.public) {
        publicAccess += 1;
      }
      if (item.restricted) {
        restrictedAccess += 1;
      }
    });
    if (publicAccess < items.length) {
      this.setState({ accessType: 'private' });
    } else if (restrictedAccess < items.length) {
      this.setState({ accessType: 'public' });
    } else {
      this.setState({ accessType: 'public' });
    }

    if (mode === 'collections') {
      let spreadPermissions = 0;
      let spreadPermissionsAlways = 0;
      let spreadPermissionsCollections = 0;
      let my = false;
      items.forEach((item) => {
        if (item.spread_permissions) {
          spreadPermissions += 1;
        }
        if (item.spread_permissions_always) {
          spreadPermissionsAlways += 1;
        }
        if (item.spread_permissions_collections) {
          spreadPermissionsCollections += 1;
        }
        if (item.my) {
          my = true;
        }
      });

      if (spreadPermissions === items.length) {
        this.setState({
          spreadPermissions: !(getSetting('cs1') && my),
          spreadPermissionsAlways: spreadPermissionsAlways === items.length,
          spreadPermissionsCollections: spreadPermissionsCollections === items.length,
        }, () => {
          this.updateSpreadPermissions();
        });
      } else {
        this.setState({
          spreadPermissions: false,
          spreadPermissionsAlways: false,
          spreadPermissionsCollections: spreadPermissionsCollections === items.length,
        }, () => {
          this.updateSpreadPermissions();
        });
      }
    }

    this.setState({ ownerUuids: this.getOwnerUuids() });

    if (items.length === 0) {
      this.setState({ view: 'no_permissions' });
    }
  }

  getFilesPromisePool() {
    const { updateFileOnList } = this.props;
    const { files } = this.state;

    let counterFiles = 0;
    const promiseProducerFiles = () => {
      if (counterFiles < files.length) {
        const item = files[counterFiles];
        counterFiles += 1;
        return APIupdateFilePermissions(item).then((response) => {
          this.setState({ updatedItems: counterFiles });
          if (response.data && response.data.uuid) {
            updateFileOnList(response.data);
            eventDispatch('fileUpdated', response.data);
          }
        });
      }
      return null;
    };

    return new PromisePool(promiseProducerFiles, 2);
  }

  getCollectionsPromisePool() {
    const { updateCollectionOnList } = this.props;
    const {
      collections,
      sendNotifications,
    } = this.state;

    let counterCollections = 0;
    const promiseProducerCollections = () => {
      if (counterCollections < collections.length) {
        const item = collections[counterCollections];
        item.send_notifications = sendNotifications;
        counterCollections += 1;
        return APIupdateCollectionPermissions(item).then((response) => {
          updateCollectionOnList(response.data);
          eventDispatch('collectionUpdated', { reload: true, ...response.data });
        });
      }
      return null;
    };

    return new PromisePool(promiseProducerCollections, 2);
  }

  getOwnerUuids() {
    const {
      files,
      collections,
    } = this.state;

    return window._.uniq(
      files.map(f => (f.user_uuid))
        .concat(collections.map(c => (c.user_uuid))),
    );
  }

  loadFiles() {
    const {
      mode,
      files,
      collections,
    } = this.state;

    if (mode === 'files') {
      this.setState({ collectionsLoading: false });
      APIgetFilesWithPermissions({ files }).then((response) => {
        const { data } = response;
        if (data) {
          this.setState({
            files: data,
            filesCount: data.length,
          }, () => {
            this.setInitialFormData();
            const editionView = this.getEditionView();
            if (editionView) {
              this.setState({
                view: editionView,
              });
            }
          });
        }
        this.setState({ filesLoading: false });
      });
    }

    if (mode === 'collections') {
      this.setState({ filesLoading: false });
      APIgetCollectionsWithPermissions(collections).then((response) => {
        const { data } = response;
        if (data) {
          this.setState({ collections: data }, () => {
            this.setInitialFormData();
          });
        }
        this.setState({ collectionsLoading: false });
      });
    }
  }

  loadUsers() {
    this.setState({ usersLoading: true });

    return APIgetUsers().then((response) => {
      const { data } = response;
      if (data) {
        this.setState({ users: data });
      }
      this.setState({ usersLoading: false });
    });
  }

  loadGroups() {
    this.setState({ groupsLoading: true });

    return APIgetGroups({ all: true }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({ groups: data });
      }
      this.setState({ groupsLoading: false });
    });
  }

  getEditionView() {
    const { files } = this.state;
    if (files.length === 1 && (files[0].parent || files[0].parent_uuid)) {
      return files[0].searchable ? 'file-edition-searchable' : 'file-edition';
    }
    return null;
  }

  setInitialState() {
    const { view } = this.state;
    const {
      files,
      collections,
    } = this.props;

    let mode = null;
    if (files.length > 0) {
      mode = 'files';
    }
    if (collections.length > 0) {
      mode = 'collections';
    }

    const newView = view;

    this.setState({
      mode,
      files,
      collections,
      filesCount: files.length,
      collectionsCount: collections.length,
      view: newView,
    }, () => {
      this.loadFiles();
      this.updateSpreadPermissions();
    });
  }

  addSelectedGroup(groupUuid, forceMode = null) {
    const { mode } = this.state;

    const items = this.getItems(forceMode);

    const newItems = items.map((item) => {
      const newItem = item;
      if (!item.allowed_groups.includes(groupUuid)) {
        newItem.allowed_groups.push(groupUuid);
      }
      return newItem;
    });

    if ((mode === 'files' && forceMode === null) || forceMode === 'files') {
      this.setState({ files: newItems });
    }
    if ((mode === 'collections' && forceMode === null) || forceMode === 'collections') {
      this.setState({ collections: newItems });
    }
  }

  removeSelectedGroup(groupUuid) {
    const { mode } = this.state;
    const items = this.getItems();

    const newItems = items.map((item) => {
      const newItem = item;
      newItem.allowed_groups = item.allowed_groups.filter(ag => (ag !== groupUuid));
      return newItem;
    });

    if (mode === 'files') {
      this.setState({ files: newItems });
    }
    if (mode === 'collections') {
      this.setState({ collections: newItems });
    }
  }

  addSelectedUser(userUuid, forceMode = null) {
    const { mode } = this.state;
    const items = this.getItems(forceMode);

    const newItems = items.map((item) => {
      const newItem = item;
      if (!item.allowed_users.includes(userUuid)) {
        newItem.allowed_users.push(userUuid);
      }
      return newItem;
    });

    if ((mode === 'files' && forceMode === null) || forceMode === 'files') {
      this.setState({ files: newItems });
    }
    if ((mode === 'collections' && forceMode === null) || forceMode === 'collections') {
      this.setState({ collections: newItems });
    }
  }

  removeSelectedUser(userUuid) {
    const { mode } = this.state;
    const items = this.getItems();

    const newItems = items.map((item) => {
      const newItem = item;
      newItem.allowed_users = item.allowed_users.filter(au => (au !== userUuid));
      return newItem;
    });

    if (mode === 'files') {
      this.setState({ files: newItems });
    }
    if (mode === 'collections') {
      this.setState({ collections: newItems });
    }
  }

  addSelected(uuid, type) {
    this.setState({ accessTouched: true });

    if (type === 'group') {
      this.addSelectedGroup(uuid);
    }
    if (type === 'user') {
      this.addSelectedUser(uuid);
    }
  }

  canUserRemove(uuid) {
    const { profile } = this.props;
    const { ownerUuids } = this.state;

    if (userIsSuperAdmin()) {
      return true;
    }

    if (userIsAdmin() && getUserSetting('view_mode') === 'admin') {
      return true;
    }

    if (ownerUuids.length === 1 && ownerUuids[0] === profile.uuid) {
      return true;
    }

    let uuids = Object.keys(this.getSelected('groups'));
    uuids = uuids.filter(u => (profile.groups.includes(u)));
    if (Object.keys(this.getSelected('users')).includes(profile.uuid)) {
      uuids.push(profile.uuid);
    }

    if (uuids.filter(u => (u !== uuid)).length === 0) {
      return false;
    }

    return true;
  }

  userHasAccess() {
    return this.canUserRemove('-');
  }

  toggleUserRemoveAlert() {
    this.setState(prevState => ({ userRemoveAlertOpen: !prevState.userRemoveAlertOpen }));
  }

  removeSelected(uuid, type) {
    if (!this.canUserRemove(uuid)) {
      this.toggleUserRemoveAlert();
    } else {
      this.setState({ accessTouched: true });

      if (type === 'group') {
        this.removeSelectedGroup(uuid);
      }
      if (type === 'user') {
        this.removeSelectedUser(uuid);
      }
    }
  }

  addNewGroup(group) {
    this.loadGroups().then(() => {
      this.setState({ accessTouched: true });
      this.addSelectedGroup(group.uuid);
    });
  }

  addNewUser(user) {
    this.loadUsers().then(() => {
      this.setState({ accessTouched: true });
      this.addSelectedUser(user.uuid);
    });
  }

  updateAccessType(accessType, forceMode = null) {
    const { mode } = this.state;
    const items = this.getItems(forceMode);

    const newItems = items.map(item => ({
      ...item,
      public: accessType === 'public' || accessType === 'restricted',
      restricted: accessType === 'restricted',
    }));

    if ((mode === 'files' && forceMode === null) || forceMode === 'files') {
      this.setState({ files: newItems });
    }
    if ((mode === 'collections' && forceMode === null) || forceMode === 'collections') {
      this.setState({ collections: newItems }, () => {
        this.updateSpreadPermissions();
      });
    }

    this.setState({ accessTouched: true });
  }

  resetView(e) {
    e.preventDefault();
    this.setState({ view: null });
  }

  openSettings(e) {
    e.preventDefault();
    this.setState({ view: 'settings' });
  }

  openLinkSettings(open) {
    this.setState({ linkSettingsOpen: open });
  }

  isSaveButtonDisabled() {
    const {
      files,
      collections,
      saving,
    } = this.state;

    if (files.length === 0 && collections.length === 0) {
      return true;
    }
    if (saving) {
      return true;
    }

    return false;
  }

  handleSave() {
    const { intl, handleClose } = this.props;
    const {
      mode,
      files,
      collections,
      accessType,
      shareLink,
      view,
      accessTouched,
    } = this.state;

    if (accessTouched && accessType === 'private' && !this.userHasAccess()) {
      this.toggleUserRemoveAlert();
      return;
    }

    if (view === 'file-edition') {
      this.handleEditionUpdate(true);
      return;
    }

    if (view === 'file-edition-searchable') {
      this.handleEditionUpdate();
    }

    this.setState({ saving: true });

    if (!accessTouched) {
      if (!shareLink) {
        this.setState({ saving: false });
        handleClose();
      }
      return;
    }

    if (mode === 'files') {
      this.getFilesPromisePool().start().then(() => {
        if (!shareLink) {
          addFlashMessage({
            type: 'success',
            text: intl.formatMessage({ defaultMessage: 'Your changes have been saved' }),
          });
          performOnboardingStep('share-complete');
          handleClose();
        } else {
          this.setState({ saving: false });
        }
      });
    }

    if (mode === 'collections') {
      this.getCollectionsPromisePool().start().then(() => {
        if (!shareLink) {
          addFlashMessage({
            type: 'success',
            text: intl.formatMessage({ defaultMessage: 'Your changes have been saved' }),
          });
          handleClose();
        } else {
          performOnboardingStep('share-complete');
          this.setState({ saving: false });
        }
      });
    }

    sendTrackingEvent('access-complete', {
      files: files.length,
      collections: collections.length,
    });
  }

  handleChangeAccessType(e) {
    const { value } = e.target;
    this.setState({ accessType: value }, () => {
      this.updateAccessType(value);
    });
  }

  handleChangeSearchable(e) {
    const { files } = this.state;
    const { checked } = e.target;

    const newFile = { ...files[0] };
    newFile.searchable = checked;

    if (this.getEditionView() === 'file-edition-searchable') {
      if (checked) {
        this.setState({ view: 'file-edition-searchable' });
      } else {
        this.setState({ view: 'file-edition' });
      }
    }

    if (this.getEditionView() === 'file-edition') {
      if (!checked) {
        this.setState({ view: 'file-edition' });
      }
    }

    this.setState({
      files: [newFile],
    });
  }

  handleChangeSendNotifications(e) {
    const { checked } = e.target;
    this.setState({ sendNotifications: checked });
  }

  handleEditionUpdate(close = false) {
    const { files } = this.state;
    const {
      intl,
      callbackUpdate,
      handleClose,
      handleAddFile,
      handleUpdateFile,
      handleRemoveFile,
      filesList,
    } = this.props;

    const edition = {
      uuid: files[0].uuid,
      searchable: files[0].searchable,
    };

    this.setState({ saving: true });

    APIupdateFile(edition).then(({ data }) => {
      this.setState({
        saving: false,
        view: edition.searchable ? 'file-edition-searchable' : 'file-edition',
      }, () => {
        const { view } = this.state;
        callbackUpdate(data);
        if (data.searchable) {
          if (filesList.find(f => f.uuid === data.uuid)) {
            handleUpdateFile(data);
          } else {
            handleAddFile(data, data.parent_uuid);
          }
        } else {
          handleRemoveFile(data.uuid);
        }

        if (close && view === 'file-edition') {
          addFlashMessage({
            type: 'success',
            text: intl.formatMessage({ defaultMessage: 'Your changes have been saved' }),
          });
          handleClose();
        }
      });
    });
  }

  updateSpreadPermissions() {
    const {
      accessType,
      collections,
      spreadPermissions,
      spreadPermissionsAlways,
      spreadPermissionsPublic,
      spreadPermissionsCollections,
    } = this.state;

    const newCollections = collections.map(collection => ({
      ...collection,
      spread_permissions: !!(spreadPermissions && accessType !== 'public') || !!(spreadPermissionsPublic && accessType === 'public'),
      spread_permissions_always: !!(spreadPermissions && spreadPermissionsAlways),
      spread_permissions_collections: spreadPermissionsCollections,
    }));

    this.setState({ collections: newCollections });
  }

  handleChangeSpreadPermissions(e) {
    const { checked } = e.target;

    this.setState({
      spreadPermissions: checked,
      spreadPermissionsAlways: checked,
    }, () => {
      this.updateSpreadPermissions();
    });
  }

  handleChangeSpreadPermissionsAlways(e) {
    const { value } = e.target;

    this.setState({ spreadPermissionsAlways: value === 'true' }, () => {
      this.updateSpreadPermissions();
    });
  }

  handleChangeSpreadPermissionsPublic(e) {
    const { checked } = e.target;

    this.setState({ spreadPermissionsPublic: checked }, () => {
      this.updateSpreadPermissions();
    });
  }

  handleChangeSpreadPermissionsCollections(e) {
    const { checked } = e.target;

    this.setState({ spreadPermissionsCollections: checked }, () => {
      this.updateSpreadPermissions();
    });
  }

  handleAddingTemplate(addingTemplate) {
    this.setState({ addingTemplate });
  }

  render() {
    const {
      mode,
      accessType,
      filesCount,
      collectionsCount,
      updatedItems,
      filesLoading,
      collectionsLoading,
      usersLoading,
      groupsLoading,
      view,
      saving,
      collections,
      linkSettingsOpen,
      userRemoveAlertOpen,
      addingTemplate,
    } = this.state;
    const {
      intl,
      files: filesFromProps,
      handleClose,
    } = this.props;
    const loading = filesLoading || collectionsLoading;

    if (!mode) {
      return null;
    }

    const selectedGroups = this.getSelected('groups');
    const selectedUsers = this.getSelected('users');

    return (
      <ErrorBoundary>
        <AccessModalHeader
          {...this.state}
          handleClose={handleClose}
        />
        {loading && (
          <Loading />
        )}
        {((view === 'file-edition' || view === 'file-edition-searchable') && !loading) && (
          <ModalBody className={classnames({ 'modal-body-no-border': view === 'file-edition' })}>
            <AccessModalAccessEdition
              {...this.state}
              handleChangeSearchable={this.handleChangeSearchable}
              view={view}
            />
          </ModalBody>
        )}

        {((!view || view === 'file-edition-searchable') && !loading && !linkSettingsOpen) && (
          <ModalBody>
            <AccessModalAccessTypeDropdown
              {...this.state}
              openSettings={this.openSettings}
              handleChangeAccessType={this.handleChangeAccessType}
            />
            {accessType === 'private' && (
              <>
                <AccessModalAccess
                  {...this.state}
                  selectedUsers={selectedUsers}
                  selectedGroups={selectedGroups}
                  loading={usersLoading || groupsLoading}
                  handleAddItem={this.addSelected}
                  handleRemoveItem={this.removeSelected}
                  handleAddNewGroup={this.addNewGroup}
                  handleAddNewUser={this.addNewUser}
                />
                {mode === 'collections' && (
                  <AccessModalNotifications
                    {...this.state}
                    handleChangeSendNotifications={this.handleChangeSendNotifications}
                  />
                )}
              </>
            )}

            <Modal isOpen={userRemoveAlertOpen} toggle={this.toggleUserRemoveAlert}>
              <ModalHeader className="modal-header-center">
                {intl.formatMessage({ defaultMessage: 'Unable to remove access' })}
              </ModalHeader>
              <ModalBody>
                {intl.formatMessage({
                  defaultMessage: `Making this change will remove your access and it is not allowed.`,
                })}
              </ModalBody>
              <ModalFooter>
                <div className="modal-footer-wrapper">
                  <Button color="primary" onClick={this.toggleUserRemoveAlert}>Close</Button>
                </div>
              </ModalFooter>
            </Modal>
          </ModalBody>
        )}

        {(view === 'error' && !loading) && (
          <ModalBody className="modal-msg-body modal-msg-error">
            <Container>
              <Row>
                <Col>
                  {intl.formatMessage({ defaultMessage: 'Something went wrong. Please try again or contact us.' })}
                </Col>
              </Row>
            </Container>
          </ModalBody>
        )}

        {(view === 'no_permissions' && !loading) && (
          <ModalBody className="modal-msg-body modal-msg-error">
            <Container>
              <Row>
                <Col>
                  {intl.formatMessage({ defaultMessage: `You don't have permissions to do this.` })}
                </Col>
              </Row>
            </Container>
          </ModalBody>
        )}

        {(view === 'settings' && !loading) && (
          <ModalBody>
            <Container>
              <Row>
                <Col>
                  {(accessType === 'private' && mode === 'collections') && (
                    <AccessModalSpreadPermissions
                      {...this.state}
                      handleChangeSpreadPermissions={this.handleChangeSpreadPermissions}
                      handleChangeSpreadPermissionsAlways={this.handleChangeSpreadPermissionsAlways}
                      handleChangeSpreadPermissionsCollections={
                        this.handleChangeSpreadPermissionsCollections
                      }
                    />
                  )}
                  {(accessType === 'public' && mode === 'collections' && userCan('file.create_public')) && (
                    <div className="access-spread access-spread-form">
                      <AccessModalSpreadPermissionsPublic
                        {...this.state}
                        handleChangeSpreadPermissions={this.handleChangeSpreadPermissions}
                        handleChangeSpreadPermissionsCollections={
                          this.handleChangeSpreadPermissionsCollections
                        }
                      />
                    </div>
                  )}
                </Col>
              </Row>
            </Container>
          </ModalBody>
        )}

        {(view !== 'file-edition' && !loading && userHasCap('share')) && (
          <div className="modal-share modal-share-inline" style={{ display: view === 'settings' ? 'none' : undefined }}>
            <ShareModal
              files={filesFromProps.map(f => ({ uuid: f }))}
              collections={collections}
              inAccessModal={true}
              accessSaving={saving}
              handleClose={handleClose}
              openLinkSettings={this.openLinkSettings}
              setShareLink={(shareLink) => {
                this.setState({ shareLink });
              }}
              addingTemplate={addingTemplate}
              handleAddingTemplate={this.handleAddingTemplate}
            />
          </div>
        )}

        {((!view || view === 'file-edition' || view === 'file-edition-searchable') && !loading && !linkSettingsOpen) && (
          <ModalFooter className="justify-right">
            <div className="modal-footer-wrapper">
              <div className="buttons-group">
                <Button
                  color="primary"
                  onClick={this.handleSave}
                  disabled={this.isSaveButtonDisabled()}
                >
                  <ProcessingSpinner show={saving} />
                  {intl.formatMessage({ defaultMessage: 'Done' })}
                  {!(view === 'file-edition' || view === 'file-edition-searchable') && (
                    <ProcessingProgress
                      show={saving}
                      progress={{ total: filesCount + collectionsCount, done: updatedItems }}
                    />
                  )}
                </Button>
              </div>
            </div>
          </ModalFooter>
        )}

        {((view === 'error' || view === 'settings') && !loading) && (
          <ModalFooter className="justify-l">
            <div className="modal-footer-wrapper">
              <div className="buttons-group">
                <Button color="link" onClick={this.resetView}>
                  <i className="far fa-long-arrow-left" />
                  {intl.formatMessage({ defaultMessage: 'Back' })}
                </Button>
              </div>
            </div>
          </ModalFooter>
        )}
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  filesList: state.Files.files,
});

const mapDispatchToProps = dispatch => ({
  updateFileOnList: (file) => {
    dispatch(updateFilesOnFilesList([file]));
    dispatch(updateFilesOnSelectedFilesList([file]));
  },
  updateCollectionOnList: collection => (
    dispatch(updateCollectionOnCollectionsList(collection))
  ),
  handleAddFile: (file, targetFileUuid) => (
    dispatch(addFileToFilesList(file, targetFileUuid))
  ),
  handleUpdateFile: (file) => (
    dispatch(updateFilesOnFilesList([file]))
  ),
  handleRemoveFile: fileUuid => (
    dispatch(removeFilesFromFilesList([{ uuid: fileUuid }]))
  ),
});

AccessModal.propTypes = {
  intl: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  updateFileOnList: PropTypes.func.isRequired,
  updateCollectionOnList: PropTypes.func.isRequired,
  handleAddFile: PropTypes.func.isRequired,
  handleUpdateFile: PropTypes.func.isRequired,
  handleRemoveFile: PropTypes.func.isRequired,
  filesList: PropTypes.array.isRequired,
  files: PropTypes.array,
  collections: PropTypes.array,
  callbackUpdate: PropTypes.func,
};

AccessModal.defaultProps = {
  files: [],
  collections: [],
  callbackUpdate: () => {},
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AccessModal));
